module.exports = __webpack_public_path__ + "static/media/bird_picking_sticks01.e00f4810.png";